module.exports = __webpack_public_path__ + "assets/1d5216086753755c9ea0645b96892b38.png";